import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell, AlertTriangle, GraduationCap, Banknote, CalendarClock, Wallet, CalendarCheck } from "lucide-react";

const LEV = {
  alta: { dot: "bg-red-500", text: "text-red-600", bg: "bg-red-50" },
  media: { dot: "bg-orange-500", text: "text-orange-600", bg: "bg-orange-50" },
  bassa: { dot: "bg-slate-400", text: "text-slate-500", bg: "bg-slate-50" },
};
const ICON = { scadenza: CalendarClock, stipendi: Banknote, formazione: GraduationCap, cassa: Wallet, hr: CalendarCheck };

export default function AgencyAlerts() {
  const nav = useNavigate();
  const [alerts, setAlerts] = useState(null);
  useEffect(() => { api.get("/home/alerts").then((r) => setAlerts(r.data.alerts)).catch(() => setAlerts([])); }, []);

  if (alerts === null) return null;
  return (
    <div className="rounded-xl bg-white border border-slate-200 p-4 mb-6" data-testid="agency-alerts">
      <div className="flex items-center gap-2 mb-3">
        <Bell className="h-4 w-4 text-indigo-500" />
        <p className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold">Promemoria agenzia</p>
      </div>
      {alerts.length === 0 ? (
        <div className="text-sm text-slate-400 py-2">Nessun promemoria attivo. Tutto in ordine.</div>
      ) : (
        <div className="space-y-2">
          {alerts.map((a, i) => {
            const lev = LEV[a.livello] || LEV.bassa;
            const Icon = ICON[a.tipo] || AlertTriangle;
            return (
              <button key={i} data-testid={`alert-item-${i}`} onClick={() => a.route && nav(a.route)}
                className={`w-full text-left flex items-start gap-2.5 rounded-lg px-3 py-2 ${lev.bg} hover:brightness-95 transition-all`}>
                <span className={`mt-1 h-2 w-2 rounded-full shrink-0 ${lev.dot}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <Icon className={`h-3.5 w-3.5 ${lev.text} shrink-0`} />
                    <span className="text-sm font-medium text-slate-800 truncate">{a.titolo}</span>
                  </div>
                  {a.dettaglio && <div className="text-xs text-slate-500 mt-0.5 truncate">{a.dettaglio}</div>}
                  {a.giorni != null && (
                    <div className={`text-xs mt-0.5 ${lev.text}`}>
                      {a.giorni < 0 ? `Scaduta da ${-a.giorni}g` : a.giorni === 0 ? "Scade oggi" : `Tra ${a.giorni}g`}
                      {a.responsabile ? ` · ${a.responsabile}` : ""}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
